import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-ar-model',
    templateUrl: 'ar-model.component.html',
    styleUrls: ['ar-model.component.scss']
})
export class ArModelComponent {
    @Input() selectedFloorPlanId;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private dialogRef: MatDialogRef<any>) {
        console.log(data.floorPlanId);
        this.selectedFloorPlanId = data.floorPlanId;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
